import React, { useRef } from 'react'
import { Link } from 'react-router-dom'
const QuestFreeCredit = () => {
    const redeemFreeRef = useRef<HTMLDivElement>(null)


    const handleCloseReddemFree = () => {
        redeemFreeRef.current?.remove()
    }

    return (
        <Link to="/quest">
            <div ref={redeemFreeRef} className={`redeem-free-container`} >
                <div className="redeem-free">
                    <img className="gift-bottom" src="/redeem-success/gift-bottom.webp" alt="gift-bottom" />
                    <img className="gift-top" src="/redeem-success/gift-top.webp" alt="gift-top" />
                    <div className="redeem-free-label">
                        <span style={{ position: 'relative', zIndex: 1 }}>รับ ฿1,000</span>
                    </div>
                </div>
                <div className="redeem-free-close" onClick={handleCloseReddemFree}>
                    <i className="fa-regular fa-circle-xmark"></i>
                </div>
            </div>

            {/* <RedeemSuccess amount={redeemAmount} isOpen={isOpenRedeemSuccess} isLoadedImages={isLoadedImages} onClose={handleCloseRedeemSuccess} /> */}
        </Link>
    )
}

export default QuestFreeCredit
